import { ReactComponent as IconDownloadAll } from "@/assets/svgs/download-all-folder.svg";
import { ReactComponent as IconRedConfigure } from "@/assets/svgs/red-info-icon.svg";
import { ReactComponent as IconClose } from '@/assets/svgs/icon-close.svg';
import { ReactComponent as IconPrevious } from '@/assets/svgs/transactions-back-icon.svg';
import { ReactComponent as WarningIndicator } from '@/assets/svgs/warn-api-config-icon.svg';
import { ReactComponent as IconDownload } from "@/assets/svgs/download-white.svg";
import { ReactComponent as IconPrinter } from "@/assets/svgs/icon-printer.svg";
import { ReactComponent as IconBadgeFail } from '@/assets/svgs/iconBadgeFail.svg';
import { ReactComponent as IconBadgeProgress } from '@/assets/svgs/iconBadgeProgress.svg';
import { ReactComponent as IconBadgeSuccess } from '@/assets/svgs/iconBadgeSuccess.svg';
import { ReactComponent as IconQrCode } from "@/assets/svgs/qr-code.svg";
import DataElementAttachmentCard from '@/components/AttachmentCard/index';
import Button from '@/components/Button';
import EFormReadComponent from '@/components/EForm/eFormReadMode';
import FormRenderer from "@/components/EFormV2/EFormRenderer";
import CardConfigure from '@/componentsDS/Modal/CardConfigure';
import Modal from '@/componentsDS/Modal/Modal';
import Portal from '@/components/Portal';
import SharedDataStatus from "@/components/SharedDataStatus/index";
import Toast2 from '@/components/Toast2';
import ViewActivityLogModal from '@/components/ViewActivityLogModal/index';
import { ToastContext } from '@/context/toast/index';
import useApprovalsPage from '@/hooks/use-approvals/index';
import useConfig from '@/hooks/use-config';
import useEForm from "@/hooks/use-eform/index";
import useModal from '@/hooks/use-modal/index';
import usePage from '@/hooks/use-page';
import useTransactions from '@/hooks/use-transaction/index.js';
import useEtrDocument from "@/hooks/use-etr-document/index";
import { useNavigate, useParams, useLocation } from '@/lib/router-dom';
import apiApprovalTransaction from '@/services/api/approvals.js';
import apiDownload from '@/services/api/download.js';
import api from '@/services/api/messages.js';
import "@/translations/i18n";
import rem from '@/utils/rem.js';
import classname from 'classnames';
import { orderBy } from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import { useContext, useEffect, useMemo, useState, useRef } from 'react';
import ReactDOM from 'react-dom';
import { useDispatch, useSelector } from "react-redux";
import { clearTTDataAndFile } from '@/redux/actions/trade-trust';
import FileSaver from "file-saver";
import JSZip from "jszip";
import QRCode from "qrcode.react";
import IframeDetails from '@/pages/record-transfer/e-transferable-record/components/iframe-details/iframeDetails';
import RecordDetailsSidePanel from '@/pages/record-transfer/record-details-side-panel/index';
import ETRFileUploadComponent from '@/pages/record-transfer/etr-issuance/etr-attachments.jsx';
import Popover from "@/components/Popover/index";
import { MAKER_CHECKER_ETR_MODAL_CONTENT, MAKER_CHECKER_ETR_MODAL_CONTENT_V5 } from "@/constants/etr/etr-action/index";
import { ReactComponent as IconIndicator } from '@/assets/svgs/indicator.svg';
import { ReactComponent as IconConfigure } from '@/assets/svgs/icon-configure.svg';
import Breadcrumbs from "@/componentsDS/Breadcrumbs/index";
import { feature } from "@/utils/feature-verifier.js";
import { featureConstant } from "@/constants/configuration/feature.js";

/*=================================================1
    ETR Status
/================================================*/
export const getETRStatus = (action, eventStatus) => {
    const isETRIGPNITRV5FeatureEnabled = feature(featureConstant?.ETR_IGPNI_TR_V5);
    
    if (!action) return null;
    const pendingApprovalEnum = ["HOLDER_TRANSFER_PENDING_APPROVAL", "OWNER_TRANSFER_PENDING_APPROVAL", "OWNER_HOLDER_TRANSFER_PENDING_APPROVAL", "NOMINATION_PENDING_APPROVAL", "SURRENDER_PENDING_APPROVAL", "OWNER_HOLDER_TRANSFER_REJECTION_PENDING_APPROVAL", "OWNER_TRANSFER_REJECTION_PENDING_APPROVAL", "HOLDER_TRANSFER_REJECTION_PENDING_APPROVAL"]
    const approvedEnum = ["SURRENDER_APPROVED", "HOLDER_TRANSFER_APPROVED", "OWNER_TRANSFER_APPROVED", "OWNER_HOLDER_TRANSFER_APPROVED", "NOMINATION_APPROVED", "OWNER_HOLDER_TRANSFERRED", "OWNER_TRANSFERRED", "HOLDER_TRANSFERRED", "NOMINATED", "SURRENDERED", "OWNER_HOLDER_TRANSFER_REJECTION_APPROVED", "OWNER_TRANSFER_REJECTION_APPROVED", "HOLDER_TRANSFER_REJECTION_APPROVED"]
    const rejectedEnum = ["SURRENDER_REJECTED", "OWNER_TRANSFER_REJECTED", "HOLDER_TRANSFER_REJECTED", "OWNER_HOLDER_TRANSFER_REJECTED", "NOMINATION_REJECTED", "OWNER_HOLDER_TRANSFER_REJECTION_REJECTED", "OWNER_TRANSFER_REJECTION_REJECTED", "HOLDER_TRANSFER_REJECTION_REJECTED"]
    const updatedEnum = ["UPDATED"]

    const process = (processType) => {
        const SURRENDER = ["SURRENDER_APPROVED", "SURRENDER_REJECTED", "SURRENDER_PENDING_APPROVAL", "SURRENDERED"]
        const NOMINATION = ["NOMINATION_APPROVED", "NOMINATION_REJECTED", "NOMINATION_PENDING_APPROVAL", "NOMINATED"]
        const HOLDER_TRANSFER = ["HOLDER_TRANSFER_PENDING_APPROVAL", "HOLDER_TRANSFER_APPROVED", "HOLDER_TRANSFER_REJECTED", "HOLDER_TRANSFERRED"]
        const OWNER_TRANSFER = ["OWNER_TRANSFER_PENDING_APPROVAL", "OWNER_TRANSFER_APPROVED", "OWNER_TRANSFER_REJECTED", "OWNER_TRANSFERRED", "ENDORSEMENT_PENDING_APPROVAL"]
        const OWNER_HOLDER_TRANSFER = ["OWNER_HOLDER_TRANSFER_PENDING_APPROVAL", "OWNER_HOLDER_TRANSFER_APPROVED", "OWNER_HOLDER_TRANSFER_REJECTED", "OWNER_HOLDER_TRANSFERRED"]
        const HOLDER_TRANSFER_REJECT = ["HOLDER_TRANSFER_REJECTION_PENDING_APPROVAL", "HOLDER_TRANSFER_REJECTION_APPROVED", "HOLDER_TRANSFER_REJECTION_REJECTED"]
        const OWNER_TRANSFER_REJECT = ["OWNER_TRANSFER_REJECTION_PENDING_APPROVAL", "OWNER_TRANSFER_REJECTION_APPROVED", "OWNER_TRANSFER_REJECTION_REJECTED"]
        const OWNER_HOLDER_TRANSFER_REJECT = ["OWNER_HOLDER_TRANSFER_REJECTION_PENDING_APPROVAL", "OWNER_HOLDER_TRANSFER_REJECTION_APPROVED", "OWNER_HOLDER_TRANSFER_REJECTION_REJECTED"]
        if (SURRENDER.includes(processType)) {
            return isETRIGPNITRV5FeatureEnabled ? "Record surrender" : "Surrender";
        } else if (HOLDER_TRANSFER.includes(processType)) {
            return "Holdership transfer";
        } else if (OWNER_TRANSFER.includes(processType)) {
            return "Ownership transfer";
        } else if (OWNER_HOLDER_TRANSFER.includes(processType)) {
            return "Ownership & Holdership transfer";
        } else if (HOLDER_TRANSFER_REJECT.includes(processType)) {
            return "Holdership transfer rejection";
        } else if (OWNER_TRANSFER_REJECT.includes(processType)) {
            return "Ownership transfer rejection";
        } else if (OWNER_HOLDER_TRANSFER_REJECT.includes(processType)) {
            return "Ownership and Holdership transfer rejection";
        } else if (NOMINATION.includes(processType)) {
            return "Ownership nomination";
        }
        return null;
    }

    if (pendingApprovalEnum.includes(action)) {
        return { icon: <IconBadgeProgress />, message: `${process(action)} is pending approval` }
    } else if (approvedEnum.includes(action)) {
        return { icon: <IconBadgeSuccess />, message: `${process(action)} was approved` }
    } else if (rejectedEnum.includes(action)) {
        return { icon: <IconBadgeFail />, message: `${process(action)} was denied` }
    } else if (updatedEnum.includes(action)) {
        return { icon: <IconBadgeSuccess />, message: `${process(eventStatus)} is pending approval` }
    } else {
        return null
    }
}

const Page = ({
    defaultFileFormat = "",
    defaultFileType = "",
    defaultIncludeAttachments = false,
    defaultRejectInput = "",
}) => {

    /*=================================================1
        General
    /================================================*/
    const { breadcrumbsItems, setBreadcrumbsItems } = usePage(
		{
			title: "Transaction",
			breadcrumbs: [
				{
					label: '',
					link: '/'
				 },
				{
					label: 'Approvals',
					link: '/approvals'
				},
				{
					label: 'Transaction',
					link: ''
				}
			]
		 }
	)
    const { goTo } = useNavigate();

    const { transactionRequestId, transferableRecordId } = useParams()

    const [attachmentList, setAttachmentList] = useState([])

    const [rejectInput, setRejectInput] = useState(defaultRejectInput)

    const { addToastMessage } = useContext(ToastContext)

    const { currentState } = useLocation();
    const transactionType = currentState?.transactionType;
    const isETRIGPNITRV5FeatureEnabled = feature(featureConstant?.ETR_IGPNI_TR_V5);

    /*=================================================
        Modal
    /================================================*/

    const { visible: visibleDownloadAllData, show: showDownloadAllData, hide: hideDownloadAllData } = useModal()
    const { visible: visibleViewRequestLog, hide: hideViewRequestLog, show: showViewRequestLog } = useModal();
    const { visible: visibleRejectRequest, hide: hideRejectRequest, show: showRejectRequest } = useModal();
    const { visible: visibleApproveRequest, hide: hideApproveRequest, show: showApproveRequest } = useModal();

    /*=================================================
        Options
    /================================================*/

    const [fileType, setFileType] = useState(defaultFileType)
    const [downloadFileFormat, setDownloadFileFormat] = useState(defaultFileFormat)
    const [fileSize, setFileSize] = useState(0)
    const [totalFiles, setTotalFiles] = useState(0)
    const [includeAttachments, setIncludeAttachments] = useState(defaultIncludeAttachments)

    /*=================================================
        Error Modal
    /================================================*/
    const [error, setError] = useState()
    function handleApprovalsTransactionError() {
        setError()
    }

    /*=================================================
        Routes
    /================================================*/

    function goBack() {
        return goTo('/approvals')
    }

    function changeFileType(value) {
        if ((fileType === 'zip' && value !== 'zip') || value === 'tradetrust') {
            setDownloadFileFormat()
            setIncludeAttachments()
        }
        setFileType(value);
    }

    /*=================================================
        API
    /================================================*/

    const { config, systems } = useConfig()
    const { fetchOne, currentItem: transactionRequestItem, errorMsg: errorTransaction, loading, setLoading } = useApprovalsPage();
    const { activityLog, getActivityLogByTransactionRequestId, } = useTransactions()
    const { error: dataExpiryError } = useSelector(state => state.dataExpiry)
    const currentItem = useMemo(() => {
        return transactionRequestItem?.messageStore ?? {}
    }, [transactionRequestItem])
    const [messageId, setMessageId] = useState();
    const [previousPayload, setPreviousPayload] = useState(null);
    const [changedFields, setChangedFields] = useState(null);
    const [schema, setSchema] = useState(null);
    const { payload, setPayload, getFullJson, extractCombinedSchema, getSchemaWithoutAttachment } = useEForm();
    const [etrDetails, setETRDetails] = useState(null);

    useEffect(() => {
        if (dataExpiryError) {
            setError(dataExpiryError)
        } else {
            setError(errorTransaction)
        }
    }, [dataExpiryError, errorTransaction])

    useEffect(() => {
        const attachmentLists = currentItem?.attachments?.map((_item, index) => ({ ...currentItem.attachments[index], id: index, $selected: false }))
        const sortedOptions = orderBy(attachmentLists, [option => option.filename.toLowerCase()], ["asc"]);
        setAttachmentList(sortedOptions)

        setMessageId(currentItem?.id);
    }, [currentItem])

    useEffect(() => {
        fetchOne(transactionRequestId)
        getActivityLogByTransactionRequestId(transactionRequestId)
    }, [config])

    useEffect(() => {
        const elementSchema = currentItem?.dataElement?.elementSchema
        let payload = currentItem?.payload

        if (Array.isArray(payload)) {
            payload = payload[0];
        }

        const plainSchema = extractCombinedSchema(
            elementSchema,
            payload
        );
        const schemaWithoutAttachment = getSchemaWithoutAttachment(plainSchema);

        setSchema(schemaWithoutAttachment);
        setPayload(getFullJson(schemaWithoutAttachment, payload));
    }, [currentItem?.dataElement]);

    useEffect(() => {
        if (transactionRequestItem?.status === 'PENDING_APPROVAL') {
            activityLog.sort((a, b) => new Date(b.created) - new Date(a.created));
            const lastUpdatedIndex = activityLog.findIndex(item => item.action === "UPDATED");
            const updatedEventLog = activityLog[lastUpdatedIndex];
            const changedFields = updatedEventLog?.transactionRequestLog?.messageStoreChangeHistory?.changedFields;
            setChangedFields(changedFields);

            const eventLogWithChangedHistory = activityLog?.filter((item) => item?.transactionRequestLog?.messageStoreChangeHistory && item?.transactionRequestLog?.messageStoreChangeHistory?.id !== updatedEventLog?.transactionRequestLog?.messageStoreChangeHistory?.id);
            setPreviousPayload(eventLogWithChangedHistory?.[0]?.transactionRequestLog?.messageStoreChangeHistory?.changedPayload);
        }
    }, [activityLog, currentItem])

    /*=================================================
        Function
    /================================================*/
    async function handleApproveTransactionRequest() {
        hideApproveRequest()
        setLoading(true)

        const [error] = await apiApprovalTransaction.approve(transactionRequestId)
        setLoading(false)

        if (error) {
            const errorMessage = error?.error?.message || "Something went wrong!!!"
            return addToastMessage(errorMessage, 'error')
        }

        addToastMessage("You have successfully approved the request.", 'success')
        if (transactionType === "SHARED_DATA") {
            fetchOne(transactionRequestId)
            getActivityLogByTransactionRequestId(transactionRequestId)
        }
        else {
            return goTo('/approvals/transaction/success', { type: "Request Approved!", transactionRequestId, transferableRecordId })
        }
    }

    async function handleRejectTransactionRequest() {
        setRejectInput('')
        hideRejectRequest()
        setLoading(true)

        const [error] = await apiApprovalTransaction.reject(transactionRequestId, { "reason": rejectInput })
        setLoading(false)

        if (error) {
            const errorMessage = error?.error?.message || "Something went wrong!!!"
            return addToastMessage(errorMessage, 'error')
        }

        addToastMessage("You have rejected the request.", 'success')
        if (transactionType === "SHARED_DATA") {
            fetchOne(transactionRequestId)
            getActivityLogByTransactionRequestId(transactionRequestId)
        }
        else {
            goTo('/approvals/transaction/success', { type: "Request Rejected!", transactionRequestId, transferableRecordId })
        }
    }

    async function checkApprovalTransactionFileSize() {
        const [error, data] = await api.checkFileSize({
            id: messageId
        })

        if (error) {
            return setError(error?.error?.message || "Failed to check file size")
        }

        setFileSize(data.totalFileSize)
        setTotalFiles(data.totalFiles)
    }

    async function downloadApprovalTransactionFile() {
        const [error, result] = await api.downloadFile({ id: messageId }, downloadFileFormat ?? fileType, {
            params: {
                "includeAttachments": includeAttachments
            }
        })

        if (error) {
            return setError(error?.error?.message || "Failed to download file(s)")
        }
        hideDownloadAllData()

        const link = document.createElement("a");

        if (includeAttachments == "false") {
            if (downloadFileFormat === "json") {
                const href = `data:text/json;charset=utf-8,${encodeURIComponent(JSON.stringify(result))}`
                link.href = href;
                link.download = `${currentItem?.dataElement.dataElementId + ".json"}`;
                link.click();
                setDownloadFileFormat("")
                return
            }

            if (downloadFileFormat === "csv") {
                const path = `data:text/csv;charset=utf-8,%EF%BB%BF${encodeURIComponent(result)}`
                link.href = path;
                link.download = `${currentItem?.dataElement.dataElementId + ".csv"}`;
                link.click();
                setDownloadFileFormat("")
                return
            }
        }


        if (fileType === 'tradetrust') {
            const item = attachmentList.find(x => x.isGeneratedTT === true);

            const [error, result] = await apiDownload.download(item.file_content)

            if (error) {
                return setError(error?.error?.message || "Unable to download file(s)")
            }

            const data = `data:application/pdf;base64,${result}`
            const link = document.createElement("a")
            link.href = data
            link.download = `${currentItem?.dataElement.id + ".tt"}`;
            link.click()
            setDownloadFileFormat("")
            return
        }

        const path = `data:application/zip;base64,${result}`
        link.href = path;
        link.download = "attachment.zip";
        link.click();
        setDownloadFileFormat("")
    }

    async function downloadApprovalTransactionPayload() {

        setLoading(true)
        const [error, result] = await api.downloadFile({ id: messageId }, "csv", {
            params: {
                "includeAttachments": false
            }
        })
        setLoading(false)
        if (error) {
            return setError(error?.error?.message || "Failed to download file(s)")
        }
        const link = document.createElement("a");
        const href = `data:text/csv;charset=utf-8,%EF%BB%BF${encodeURIComponent(result)}`
        link.href = href;
        link.download = `${currentItem?.dataElement.dataElementId + ".csv"}`;
        link.click();
    }

    function addInputErrorClass() {
        if (rejectInput.startsWith(" ")) {
            return 'transaction-reject__input error'
        } else {
            return 'transaction-reject__input'
        }
    }

    const InputErrorContent = () => {
        return (
            <div className='inputErrorContent'>
                {rejectInput.startsWith(" ") ? (<div className='errorMessage'><WarningIndicator /> This field is require.</div>) : (<div></div>)}
                <div className='transaction-reject__countInputWords'><span>{rejectInput.length}</span>/200</div>
            </div>
        )
    }

    /*=================================================
        General
    /================================================*/

    const getApprovalTransactionHeadingClass = classname({
        "approvals-transaction title-header transactions-eform-heading__bottom": true,
    })

    let foundTransactionSystem;

    if (currentItem?.type !== 'STORE') {
        if (systems.filter(x => x.systems && x.systems.length > 0 && x.name !== 'My Pitstop').length > 0) {
            foundTransactionSystem = systems.map(org => org.systems).flat().find(x => x.id === (currentItem?.sysId ?? currentItem?.systemId))
        }
        else {
            foundTransactionSystem = systems.map(org => org.system).find(x => x.id === (currentItem?.sysId ?? currentItem?.systemId))
        }
    }

    const foundTransactionOrg = currentItem?.type === 'STORE' ? undefined : systems.find(system => system.id === currentItem?.orgId)
    const on_behalf_of_id = currentItem?.onBehalfOf?.[0]?.id;
    const foundOnBehalfOf = on_behalf_of_id && systems.find(org => org.id === on_behalf_of_id) ? systems.find(org => org.id === on_behalf_of_id) : undefined;
    const onBehalfOfName = foundOnBehalfOf?.name

    const statusLookup = {
        'PENDING_APPROVAL': { text: "Created", date: transactionRequestItem?.created },
        'APPROVED': { text: "Shared", date: transactionRequestItem?.modified },
        'REJECTED': { text: "Created", date: transactionRequestItem?.created },
    };

    /*=================================================
        ETR Maker Checker Transactions
    /================================================*/
    const [qrCodePopover, setQrCodePopover] = useState(false);
    const [downloadUrl, setDownloadUrl] = useState(null);
    const [fileLists, setFileLists] = useState([]);
    const [ttFileName, setTTFileName] = useState();
    const dispatch = useDispatch()
    const ttData = useSelector((state) => state.tt);
    const iframeRef = useRef();
    const attachmentRef = useRef();
    const { renderUrl, docData, ttDocument } = ttData?.data ?? {};
    const qrcodeUrl = docData?.links?.self?.href;

    const SELECTED_TAB_VIEW = { ASSET_DATA: "assetData", ATTACHMENTS: "attachments" };
    const [selectedTabView, setSelectedTabForView] = useState("assetData");

    const {
        etrDocErrorMsg,
        fetchEtrDocumentDetails,
        etrDocDetails,
        etrDocListLoading,
        fetchEtrDocumentBlockchainDetails,
        etrDocBlockchainDetails,
        etrDocBlockchainDetailsLoading,
    } = useEtrDocument();

    useEffect(() => {
        setTTFileName(undefined);
        return () => {
            dispatch(clearTTDataAndFile());
        }
    }, []);

    useEffect(() => {
        if (etrDocDetails?.name) {
			setBreadcrumbsItems([
				{
					label: '',
					link: '/'
				 },
				{
					label: 'Approvals',
					link: '/approvals'
				},
				{
					label: etrDocDetails?.name,
					link: ''
				}
			])
        }
    }, [etrDocDetails])

    useEffect(() => {
        if (ttDocument) {
            const blob = new Blob([JSON.stringify(ttDocument)], { type: "text/json" });
            const url = URL.createObjectURL(blob);
            setDownloadUrl(url);
            return () => {
                URL.revokeObjectURL(url);
            };
        }
    }, [ttDocument]);

    useEffect(() => {
        if (docData?.attachments?.length > 0) {
            const attachments = docData.attachments?.map((item) => {
                return {
                    data: item?.data,
                    name: item?.filename ?? item?.fileName,
                    mimeType: item?.mimeType,
                }
            })
            setFileLists(attachments);
        }
    }, [docData?.attachments]);

    useEffect(() => {
        if (transferableRecordId) {
            dispatch(clearTTDataAndFile())
            fetchEtrDocumentDetails(transferableRecordId);
        }
    }, [transferableRecordId]);

    useEffect(() => {
        if (transactionRequestItem && etrDocDetails) {
            formatETRDocDetails(transactionRequestItem, etrDocDetails)
        }
    }, [transactionRequestItem, etrDocDetails])

    /*=================================================
        Print Functionality
    /================================================*/
    const handlePrint = () => {
        if (selectedTabView === SELECTED_TAB_VIEW.ASSET_DATA) {
            iframeRef.current?.handlePrint();
        } else if (selectedTabView === SELECTED_TAB_VIEW.ATTACHMENTS) {
            attachmentRef?.current?.handlePrint();
        }
    };

    /*=================================================
        Download File Functionality
    /================================================*/
    function handleDownload(selectedTabView) {
        if (selectedTabView === SELECTED_TAB_VIEW.ASSET_DATA) {
            const blob = new Blob([JSON.stringify(ttDocument)], { type: "text/json" });
            FileSaver.saveAs(blob, etrDocDetails?.name.includes(".tt") ? etrDocDetails?.name : (etrDocDetails?.name + ".tt"));
        } else if (selectedTabView === SELECTED_TAB_VIEW.ATTACHMENTS) {
            if (fileLists.length === 0) return;
            const zip = new JSZip();
            fileLists.forEach((file) => {
                const { data, name } = file;
                zip.file(name, data, { base64: true });
            })
            zip.generateAsync({ type: "blob" }).then(function (cont) {
                FileSaver.saveAs(cont, "attachments.zip");
            });
        }
    }

    function getModalContent(transferableStoreType) {
        const defaultText = "Are you sure you want to approve the holder transfer request?";
        const modalContent = {
            "TRANSFER_OWNER": MAKER_CHECKER_ETR_MODAL_CONTENT.TRANSFER_OWNERSHIP.body,
            "TRANSFER_HOLDER": MAKER_CHECKER_ETR_MODAL_CONTENT.TRANSFER_HOLDER.body,
            "TRANSFER_OWNER_HOLDER": MAKER_CHECKER_ETR_MODAL_CONTENT.TRANSFER_OWNERSHIP_HOLDERSHIP.body,
            "NOMINATE_OWNER": MAKER_CHECKER_ETR_MODAL_CONTENT.NOMINATE_OWNER.body,
            "ENDORSE_OWNER": MAKER_CHECKER_ETR_MODAL_CONTENT.ENDORSE_OWNERSHIP.body,
            "SURRENDER": isETRIGPNITRV5FeatureEnabled ? MAKER_CHECKER_ETR_MODAL_CONTENT_V5.SURRENDER.body : MAKER_CHECKER_ETR_MODAL_CONTENT.SURRENDER.body
        };

        return modalContent[transferableStoreType] || defaultText;
    };

    function formatETRDocDetails(txnItem, etrDocDetails) {
        const { transferableStore, ...restOfTxnItem } = txnItem
        setETRDetails({
            ...restOfTxnItem,
            eventStatus: etrDocDetails?.eventStatus,
            type: etrDocDetails?.type,
            transferableStores: Array.isArray(transferableStore) ? transferableStore : [transferableStore],
        });
    }

    return (
        <>
			<Breadcrumbs breadcrumbItems={breadcrumbsItems} />
            {transactionType === "SHARED_DATA" && <>
                <div className={getApprovalTransactionHeadingClass}>
                    <div className="transaction-title-header__left">
                        <span className="transaction-title-header__title__status--row">
                            <div className='transaction-title-header__heading'>
                                {"Transaction"}
                            </div>

                            <div className='title-header__mc_status'>
                                <SharedDataStatus status={transactionRequestItem?.status} />
                            </div>
                        </span>
                    </div>
                    <div className="title-header__right">
                        <Button round
                            full maxWidth={140} text={"Download All"}
                            submit={() => {
                                checkApprovalTransactionFileSize()
                                showDownloadAllData()
                                setFileType("zip")
                                setIncludeAttachments("true")
                                setDownloadFileFormat("")
                            }}
                            disabled={transactionRequestItem?.status.toUpperCase() === "EXPIRED"}
                        />
                    </div>
                </div>

                <div className="approvals-transaction title-header__title__meta__cols">
                    {
                        (currentItem?.referenceId && currentItem?.referenceId !== "" && currentItem?.referenceId !== null) && (
                            <div className="transaction-title-header__title__meta__col">
                                Reference ID {currentItem?.referenceId}
                            </div>
                        )
                    }
                </div>

                <div className="approvals-transaction title-header__title__meta__cols">
                    <div className="approvals-transaction-header transaction-title-header__title__meta__col">
                        {currentItem?.dataElement?.name ?? currentItem?.dataElement?.elementName} {foundTransactionOrg && (
                            <>
                                {["PUSH", "STORE", "PROVIDE"].includes(currentItem?.type ?? currentItem?.messageType) && (
                                    <>
                                        to {foundTransactionOrg?.name}
                                        {onBehalfOfName && (
                                            <span className="data-table__table__body__content__proxy">
                                                &ensp; on behalf of  {onBehalfOfName}
                                            </span>
                                        )}
                                    </>
                                )}
                                {
                                    (currentItem?.type === "PULL" || currentItem?.type === "RECEIVE") && (
                                        <>
                                            from {foundTransactionOrg?.name}
                                            {onBehalfOfName && (
                                                <span className="data-table__table__body__content__proxy">
                                                    &ensp; on behalf of {onBehalfOfName}
                                                </span>
                                            )}
                                        </>
                                    )
                                }
                            </>
                        )
                        }
                        {
                            foundTransactionSystem && (
                                <span className="data-table__table__body__content__proxy">
                                    &ensp; via {foundTransactionSystem?.name}
                                </span>
                            )
                        }
                    </div>
                </div>

                <div className="approvals-transaction title-header__title__meta__cols">
                    <div className="transaction-title-header__title__meta__col-date">
                        {
                            <>
                                {statusLookup[transactionRequestItem?.status?.toUpperCase()]?.text} &nbsp;
                                {moment(statusLookup[transactionRequestItem?.status?.toUpperCase()]?.date || null).format('DD/MM/YYYY h:mm A')}
                            </>
                        }
                    </div>
                </div>

                <div className="approvals-transaction title-header__title__meta__cols">
                    <div className='transaction-title-header__title__meta__col title-header__title__view-request-log' data-testid="view-request-log"
                        onClick={() => showViewRequestLog()}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                                showViewRequestLog();
                            }
                        }}
                    >
                        View Activity Log
                    </div>
                </div>

                <div className="approvals-transaction transactions-data-element-payload-data-row__details">
                    {currentItem?.payload && <div className="data-element-payload-data-row__eform data-element-payload-data-row__section">
                        <div className="transactions-data-element-payload-data-heading-actions" onClick={() => downloadApprovalTransactionPayload()}
                            onKeyDown={(e) => {
                                if (e.key === "Enter" || e.key === " ") {
                                    downloadApprovalTransactionPayload();
                                }
                            }}
                            data-testid="transaction-download-icon"
                        >
                            <div className="transactions-data-element-payload-action-icons tooltip">
                                <div className="attachment-card__btn-download-all">
                                    <div className="attachment-card__btn-icon"><IconDownloadAll /></div>
                                    <div className="attachment-card__btn-text">Download</div>
                                </div>
                                <span className="tooltiptext">Download as CSV</span>
                            </div>
                        </div>
                        <div className="transactions-data-element-payload-heading-details">
                            <div className="transactions-data-element-payload-heading-details-left">{currentItem?.dataElement?.name ?? currentItem?.dataElement?.elementName}</div>
                            <div className="transactions-data-element-payload-heading-details-right">*Refers to mandatory fields</div>
                        </div>
                        <div className="transaction__eform-header-border"></div>
                        <FormRenderer
                            payload={payload}
                            schema={schema}
                            isReadOnly={true}
                            previousPayload={previousPayload}
                            changedFields={changedFields}
                        />
                    </div>}
                    <div className="data-element-payload-data-row__other-info" hidden={!currentItem?.dataElement?.elementSchema?.properties?.["attachments"]}>
                        {currentItem?.payload && <DataElementAttachmentCard
                            attachmentList={attachmentList}
                            stateType={"view"}
                            makerChecker={true}
                            setAttachmentList={setAttachmentList}
                            dataElement={currentItem?.dataElement?.name}
                            previousAttachmentList={previousPayload?.attachments}
                        />}
                    </div>
                </div>
            </>}

            {transactionType != "SHARED_DATA" && <>
                <div className="title-header transactions-eform-heading__bottom">
                    <div className="transaction-title-header__left">
                        <span className="transaction-title-header__title__status--row">
                            <div className='transaction-title-header__heading'>
                                {etrDocDetails?.name}
                            </div>
                        </span>
                    </div>
                    <div className="transaction-title-header__right">
                        <a
                            download={etrDocDetails?.name.includes(".tt") ? etrDocDetails?.name : (etrDocDetails?.name + ".tt")}
                            target="_black"
                            href={downloadUrl}
                        >
                            <div className="etr-maker-checker__download-button">
                                <IconDownloadAll />
                                <div> Download .TT File</div>
                            </div>
                        </a>
                    </div>
                </div>

                <div className="etr-issuance__details">
                    <div className="etr-maker-checker-issuance__details__row">
                        <div className="etr-issuance__details__left">
                            <div className="etr-issuance__details__left-icon">
                                {getETRStatus(activityLog?.[0]?.action)?.icon}
                            </div>
                            <div>
                                <div className='etr-issuance__record-status'>
                                    {getETRStatus(activityLog?.[0]?.action, activityLog?.[0]?.transferableRecord?.eventStatus)?.message}
                                </div>
                                <div className='etr-issuance__record-date'>{moment(activityLog?.[0]?.created ?? etrDocDetails?.created).format("DD MMM YYYY, h:mm A")}</div>
                            </div>
                        </div>
                        <div className="etr-issuance__details__right"
                            onClick={() => showViewRequestLog()}
                            onKeyDown={() => showViewRequestLog()}
                            role="none">
                            View Activity Log
                        </div>
                    </div>
                    {etrDocErrorMsg ? <div className="etr-issuance__record-error-msg">
                        <div className="etr-issuance__record-error-msg-bold">
                            Note:
                        </div>
                        Unable to retrieve blockchain information for now. You may proceed by retry via “Retry” button.
                    </div> :
                        <div className="etr-issuance__record-pending-message">
                            <div className="etr-issuance__record-error-msg-bold">
                                Note:
                            </div>
                            You are reviewing a snapshot of the ETR details as they were when this request was initiated. Approval is based on this snapshot, not on any updates that may have happened on the blockchain afterward.
                        </div>
                    }
                </div>

                <div className='etr-data-element-payload__eform-data'>
                    <div className="etr-data-element-payload__eform">
                        <div className='etr-data-element-payload__eform-heading'>
                            <div className="left">
                                <div className='etr-data-element-payload-review-status-name'>
                                    {!!ttFileName && ttFileName + ":"}
                                </div>
                                <div
                                    className={selectedTabView === SELECTED_TAB_VIEW.ASSET_DATA ? `etr-data-element-payload-review-status-active` : `etr-data-element-payload-review-status`}
                                    onClick={() => setSelectedTabForView(SELECTED_TAB_VIEW.ASSET_DATA)}
                                    onKeyDown={() => setSelectedTabForView(SELECTED_TAB_VIEW.ASSET_DATA)}
                                    role="none"
                                >
                                    Asset Data
                                </div>
                                <div
                                    className={selectedTabView === SELECTED_TAB_VIEW.ATTACHMENTS ? `etr-data-element-payload-review-status-active` : `etr-data-element-payload-review-status`}
                                    onClick={() => setSelectedTabForView(SELECTED_TAB_VIEW.ATTACHMENTS)}
                                    onKeyDown={() => setSelectedTabForView(SELECTED_TAB_VIEW.ATTACHMENTS)}
                                    role="none"
                                >
                                    Attachments
                                </div>
                            </div>
                            <div className="right">
                                {(renderUrl && (
                                    (selectedTabView === SELECTED_TAB_VIEW.ASSET_DATA) ||
                                    (selectedTabView === SELECTED_TAB_VIEW.ATTACHMENTS && fileLists.length > 0)
                                ) && (
                                        <>
                                            {qrcodeUrl && (
                                                <div className="button_container__button">
                                                    <Popover visible={qrCodePopover} className=""
                                                        options={{ modifiers: [{ name: 'offset', options: { offset: [25, 10] } }] }}
                                                    >
                                                        <Popover.Trigger>
                                                            <div className="qr_code__relative" data-testid="qr_code__relative"
                                                                onClick={() => {
                                                                    setQrCodePopover(!qrCodePopover);
                                                                }}
                                                                onKeyDown={() => {
                                                                    setQrCodePopover(!qrCodePopover);
                                                                }}
                                                                role="none"
                                                            >
                                                                <IconQrCode />
                                                            </div>
                                                        </Popover.Trigger>
                                                        <Popover.Content>
                                                            <div data-testid="qr-code-svg" className={qrCodePopover ? "qr_code qr_code__block" : "qr_code qr_code__hidden"}>
                                                                <QRCode
                                                                    value={qrcodeUrl}
                                                                    bgColor="#FFFFFF"
                                                                    fgColor="#000000"
                                                                    level="Q"
                                                                    size={200}
                                                                    imageSettings={{
                                                                        src: `/img/logo-qrcode.png`,
                                                                        height: 50,
                                                                        width: 55,
                                                                        excavate: true,
                                                                    }}
                                                                    onClick={() => {
                                                                        window.open(qrcodeUrl, "_blank");
                                                                    }}
                                                                />
                                                            </div>
                                                        </Popover.Content>
                                                    </Popover>
                                                </div>
                                            )}

                                            <div className="button_container__button">
                                                <span
                                                    className="print__icon"
                                                    data-testid="print__icon"
                                                    onKeyDown={() => handlePrint()}
                                                    onClick={() => handlePrint()}
                                                    role="none"
                                                >
                                                    <IconPrinter />
                                                </span>
                                            </div>
                                            <div className="button_container__button">
                                                <a
                                                    role="none"
                                                    data-testid="download__icon"
                                                    onClick={() => handleDownload(selectedTabView)}
                                                    onKeyDown={() => handleDownload(selectedTabView)}
                                                    data-tooltip-id="tooltip"
                                                    data-tooltip-content={selectedTabView === SELECTED_TAB_VIEW.ASSET_DATA ? `Download .TT` : `Download All Attachments`}
                                                >
                                                    <IconDownload />
                                                </a>
                                            </div>
                                        </>
                                    )
                                )}
                            </div>
                        </div>
                        {selectedTabView === SELECTED_TAB_VIEW.ASSET_DATA && <div className='etr-issuance-eform-data'>
                            <IframeDetails
                                seTTFileName={setTTFileName}
                                ref={iframeRef}
                            />
                        </div>}
                        {selectedTabView === SELECTED_TAB_VIEW.ATTACHMENTS && <div className='etr-issuance-eform-data'>
                            <div className="etr-eform-row-heading">Attachment</div>
                            <ETRFileUploadComponent
                                ref={attachmentRef}
                                fileLists={fileLists}
                                isReadOnly={true}
                            />
                        </div>}
                    </div>
                    <RecordDetailsSidePanel
                        etrDocDetails={etrDetails}
                        fetchEtrDocumentBlockchainDetails={fetchEtrDocumentBlockchainDetails}
                        etrDocBlockchainDetails={etrDocBlockchainDetails}
                        etrDocBlockchainDetailsLoading={etrDocBlockchainDetailsLoading}
                        etrDocErrorMsg={etrDocErrorMsg}
                        isApprovalScreen={true}
                        showBackgroundColor={true}
                    />
                </div>
            </>}

            {transactionRequestItem?.status === "PENDING_APPROVAL" && (<>
                {transactionType != "SHARED_DATA" &&
					<div className="DS__layout__footer">
						<div className="approvals-transaction etr-layout-default__sticky-confirm-bar">
							<span><IconBadgeProgress /></span>
							<span>By clicking “Approve” you also consent to the automated sharing of this ETR to the new owner.</span>
						</div>
					</div>
				}
				<div className="DS__layout__footer">
					<div className="approvals-transaction layout-default__sticky-actions">
						<div className="layout-default__sticky-actions__left">
							<Button text="Cancel"
								data-testid="approval-transaction-cancel-btn"
								noborder
								round
								submit={() => { goBack() }}
							/>
						</div>

						<div className="layout-default__sticky-actions__right" >
							<div className="overview__button_wrap">
								<Button text="Reject"
									data-testid="approval-transaction-reject-btn"
									full
									round
									error
									submit={() => { showRejectRequest() }}
								/>
								<Button text="Approve"
									data-testid="approval-transaction-approve-btn"
									full
									round
									submit={() => { showApproveRequest() }}
								/>
							</div>
						</div>
					</div>
				</div>
            </>)}

            <Modal visible={visibleRejectRequest} variant="medium" close={hideRejectRequest}>
                <CardConfigure>
                    <CardConfigure.Header>
						<CardConfigure.Header.Title>
							<div className="card-configure__header__left">
								<div className="card-configure__title">
									<div className="card-configure__title__left">
										<div className="card-configure__approval-screen__icon">
											<IconRedConfigure />
										</div>
									</div>
									<div className="card-configure__title__right">
										<div className="card-configure__title__right__top">
											Reject Request
										</div>
									</div>
								</div>
							</div>
						</CardConfigure.Header.Title>
                    </CardConfigure.Header>
                    <CardConfigure.Body>
                        <CardConfigure.Body.Col>
                            <div className="transaction-reject__content">
                                <span className='transaction-reject__message'>Are you sure you want to decline this request? The requestor will be notified.</span>
                                <textarea
                                    className={addInputErrorClass()}
                                    type="text"
                                    data-testid="reson-reject-input"
                                    maxLength={200}
                                    rows="6"
                                    placeholder="Reason for reject"
                                    onChange={(e) => {
                                        setRejectInput((e.target.value));
                                    }}
                                />
                                <InputErrorContent />
                            </div>

                        </CardConfigure.Body.Col>
                    </CardConfigure.Body>
                    <CardConfigure.Footer>
						<CardConfigure.Footer.Left>
							<Button
								addClass="modal__reject-cancel-btn"
								data-testid="modal-reject-cancel-btn"
								text="Cancel"
								noborder
								round
								nobackground
								submit={() => {
									hideRejectRequest();
								}}
							/>
						</CardConfigure.Footer.Left>
                        <CardConfigure.Footer.Right>
                            <span style={{ width: rem(10), display: 'inline-block' }}></span>
                            <Button
                                addClass='modal__reject-proceed-btn'
                                data-testid="modal-reject-proceed-btn"
                                text="Confirm"
                                round
                                error
                                submit={() => { handleRejectTransactionRequest() }}
                                disabled={rejectInput?.trim()?.length === 0}
                            />
                        </CardConfigure.Footer.Right>
                    </CardConfigure.Footer>
                </CardConfigure>
            </Modal>

            <Modal visible={visibleApproveRequest && transactionType === 'SHARED_DATA'} variant="medium" close={hideApproveRequest}>
                <CardConfigure>
                    <CardConfigure.Header className='modal_approval-transaction'>
                        <CardConfigure.Header.Title>
							<div className="card-configure__header__left">
								<div className="card-configure__title">
									<div className="card-configure__title__left">
										<div className={'modal_approval-transaction  '}>
											<WarningIndicator />
										</div>
									</div>
									<div className="card-configure__title__right">
										<div className="card-configure__title__right__top">
											Approve Request
										</div>
									</div>
								</div>
							</div>
						</CardConfigure.Header.Title>
                    </CardConfigure.Header>
                    <CardConfigure.Body>
                        <CardConfigure.Body.Col>
                            <div className='share__card-configure-text'>{getModalContent(transactionRequestItem?.transferableStore?.type)}</div>
                        </CardConfigure.Body.Col>
                    </CardConfigure.Body>
                    <CardConfigure.Footer>
                        <CardConfigure.Footer.Right>
                            <Button
                                text="Cancel"
                                data-testid="modal-approve-cancel-btn"
                                ghost
                                round
                                submit={() => {
                                    hideApproveRequest()
                                }}
                            />
                            <span style={{ width: rem(10), display: 'inline-block' }}></span>
                            <Button
                                text="Confirm"
                                data-testid="modal-approve-confirm-btn"
                                round
                                submit={() => { handleApproveTransactionRequest() }}
                            />
                        </CardConfigure.Footer.Right>
                    </CardConfigure.Footer>
                </CardConfigure>
            </Modal>

            <Modal visible={visibleApproveRequest && transactionType !== "SHARED_DATA"}>
                <CardConfigure>
                    <CardConfigure.Header>
                        <CardConfigure.Header.Title>
							<div className="card-configure__header__left">
								<div className="card-configure__title">
									<div className="card-configure__title__left">
										<div className="card-configure__approval-screen__icon">
											<IconRedConfigure />
										</div>
									</div>
									<div className="card-configure__title__right">
										<div className="card-configure__title__right__top">
											Approve Request
										</div>
									</div>
								</div>
							</div>
						</CardConfigure.Header.Title>
                    </CardConfigure.Header>
                    <CardConfigure.Body>
                        <CardConfigure.Body.Col>
                            <div className="etr__modal__content">
                                {getModalContent(
                                    transactionRequestItem?.transferableStore
                                        ?.type
                                )}
                            </div>
                        </CardConfigure.Body.Col>
                    </CardConfigure.Body>
                    <CardConfigure.Footer>
                        <CardConfigure.Footer.Left>
                            <Button
                                addClass="etr-maker-checker__modal__cancel"
                                data-testid="modal-approve-cancel-btn"
                                text="Cancel"
                                nohover
                                noborder
                                ghost
                                submit={() => {
                                    hideApproveRequest();
                                }}
                            />
                        </CardConfigure.Footer.Left>
                        <CardConfigure.Footer.Right>
                            <Button
                                warning
                                noHover
                                round
                                data-testid="modal-approve-confirm-btn"
                                text="Confirm"
                                submit={() => {
                                    handleApproveTransactionRequest();
                                }}
                            />
                        </CardConfigure.Footer.Right>
                    </CardConfigure.Footer>
                </CardConfigure>
            </Modal>

            <Modal visible={visibleDownloadAllData} variant="medium" close={() => {
                                hideDownloadAllData()
                                setFileType()
                                setIncludeAttachments()
                            }}>
                <CardConfigure >
                    <CardConfigure.Header>
						<CardConfigure.Header.Title>
							<div className="card-configure__header__left">
								<div className="card-configure__title">
									<div className="card-configure__title__left">
										<div className="card-configure__icon">
											<IconConfigure />
										</div>
									</div>
									<div className="card-configure__title__right">
										<div className="card-configure__title__right__top">
											Download Transaction
										</div>
									</div>
								</div>
							</div>
						</CardConfigure.Header.Title>
                    </CardConfigure.Header>
                    <CardConfigure.Body>
                        <CardConfigure.Body.Col>
                            <div className='download-approvals-transaction'>
                                <div className="download-transaction__rows">
                                    <div className="approvals-transaction-row download-transaction__row">
                                        You are about to export Transaction ({fileSize}MB)
                                    </div>
                                    <div className="approvals-transaction-row download-transaction__row">
                                        <div className="approvals-transaction-left download-transaction__row__left">
                                            Export data as
                                        </div>
                                        <div className="approvals-transaction-row-right download-transaction__row__right" style={{ width: "70%" }}>
                                            <div className='download-transaction__row__left-right-flex'>
                                                <div className="approvals-transaction-radio download-transaction__row__right__radio" style={{ width: '30%' }}>
                                                    <input type="radio" value="zip" name="fileType" id="zip"
                                                        onClick={(e) => changeFileType(e.target.value)}
                                                        checked={fileType === 'zip' && includeAttachments == "true"}
                                                        onChange={() => {
                                                            return setIncludeAttachments(includeAttachments == "true" ? "false" : "true")
                                                        }}
                                                    /> <label htmlFor="zip">ZIP file</label>
                                                </div>
                                                {
                                                    currentItem?.isTTFlow && (
                                                        <div className="approvals-transaction-radio download-transaction__row__right__radio">
                                                            <input type="radio" value="tradetrust" name="fileType" id="tradetrust"
                                                                onClick={(e) => changeFileType(e.target.value)}
                                                                checked={fileType === 'tradetrust'}
                                                            /> <label htmlFor="tradetrust">TradeTrust file</label>
                                                        </div>
                                                    )
                                                }
                                            </div>

                                            {
                                                fileType !== 'tradetrust' && (
                                                    <div className="approvals-transaction-radio download-transaction__row__right__radio" style={{ marginTop: '20px' }}>
                                                        <input type="radio" value="json" name="downloadFileFormat" id="json"
                                                            onClick={(e) => setDownloadFileFormat(e.target.value)}
                                                        /> <label htmlFor="json">JSON</label>
                                                    </div>
                                                )
                                            }
                                            {
                                                fileType !== 'tradetrust' && (
                                                    <div className="approvals-transaction-radio download-transaction__row__right__radio">
                                                        <input type="radio" value="csv" name="downloadFileFormat" id="csv"
                                                            onClick={(e) => setDownloadFileFormat(e.target.value)}
                                                        /> <label htmlFor="csv">CSV</label>
                                                    </div>
                                                )
                                            }

                                        </div>
                                    </div>
                                    {
                                        fileType !== 'tradetrust' && (
                                            <div className="approvals-transaction-row download-transaction__row">
                                                <div className="download-transaction__row__left">
                                                    Include attachments
                                                </div>
                                                <div className="approvals-transaction-row-right download-transaction__row__right" style={{ width: "70%" }}>
                                                    <div className='download-transaction__row__left-right-flex'>
                                                        <div className="approvals-transaction-radio download-transaction__row__right__radio" style={{ width: '30%' }}>
                                                            <input type="radio" value={"true"} name="includeAttachment" id="yes"
                                                                checked={includeAttachments == "true"}
                                                                onClick={(e) => setIncludeAttachments(e.target.value)}
                                                                disabled={fileSize > 250 || totalFiles === 0}
                                                            /> <label htmlFor="yes">Yes</label>
                                                            {
                                                                (fileSize > 250) && (
                                                                    <span className="approvals-transaction-radio-message download-transaction__row__right__radio__message">
                                                                        Download size is too large
                                                                    </span>
                                                                )
                                                            }
                                                        </div>
                                                        <div className="approvals-transaction-radio download-transaction__row__right__radio">
                                                            <input type="radio" value={"false"} name="includeAttachment" id="no"
                                                                checked={includeAttachments == "false"}
                                                                onClick={(e) => setIncludeAttachments(e.target.value)}
                                                                disabled={fileType === 'tradetrust'}
                                                            /> <label htmlFor="no">No</label>
                                                            <span className="approvals-transaction-radio-message download-transaction__row__right__radio__message">
                                                                &nbsp; (Download data only)
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    }

                                </div>
                            </div>
                        </CardConfigure.Body.Col>
                    </CardConfigure.Body>
                    <CardConfigure.Footer>
                        <CardConfigure.Footer.Right>
                            <Button text="Cancel"
                                data-testid="cancel-downloadAll-modal"
                                ghost
                                submit={() => {
                                    hideDownloadAllData()
                                    setFileType()
                                    setIncludeAttachments()
                                }}
                            />
                            <span style={{ width: rem(10), display: 'inline-block' }}></span>
                            <Button text="Confirm"
                                data-testid="confirm-downloadAll-modal"
                                disabled={(!downloadFileFormat || !includeAttachments) && (fileType !== 'tradetrust')}
                                submit={() => {
                                    downloadApprovalTransactionFile()
                                }}
                            />
                        </CardConfigure.Footer.Right>
                    </CardConfigure.Footer>
                </CardConfigure>
            </Modal>

            {
                (etrDocListLoading || etrDocBlockchainDetailsLoading || loading) && (
                    ReactDOM.createPortal(
                        <div className='approvals-transaction modal white'>
                            <div className='loading'>
                                <img src="/loading.gif" alt="loader" />
                            </div>
                        </div>
                        , document.body
                    )
                )
            }

            <ViewActivityLogModal
                visible={visibleViewRequestLog}
                close={hideViewRequestLog}
                schema={currentItem?.dataElement?.elementSchema}
                activityLog={activityLog}
                activityLogType={transactionType === "SHARED_DATA" ? "" : "etr"}
                isApprovalScreen={true}
                etrDocDetails={etrDocDetails}
            />

            <Toast2 show={error} errorMessage={error} close={() => { handleApprovalsTransactionError() }} />
        </>
    )
}

export default Page

Page.propTypes = {
    defaultFileFormat: PropTypes.string,
    defaultFileType: PropTypes.string,
    defaultIncludeAttachments: PropTypes.bool,
    defaultRejectInput: PropTypes.string,
}
